import { Component, EventEmitter, input, Output } from '@angular/core';
import { LoadingButtonDirective } from '@premotec/pmt-bootstrap';

@Component({
  selector: 'app-switch-edu-button',
  imports: [LoadingButtonDirective],
  standalone: true,
  templateUrl: './switch-edu-button.component.html',
  styleUrl: './switch-edu-button.component.scss'
})
export class SwitchEduButtonComponent {
  public isLoading = input(false);
  public disabled = input(false);

  @Output() public switchEduIdClick = new EventEmitter<void>();

  public onSwitchEduIdClick(): void {
    if (!this.isLoading() && !this.disabled()) {
      this.switchEduIdClick.emit();
    }
  }
}
